// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5dede9fd","667":"dc6f4870","977":"b1cf1f31"}[chunkId] + ".chunk.js";
};